export default __webpack_public_path__ + "static/media/1580.75b21001.png";